import ConnectorModel from '@src/slide/domain/ui-model/element-modeles/connector-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import PictureModel from '@src/slide/domain/ui-model/element-modeles/picture-model';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import { ElementModelType } from '@src/slide/domain/ui-model/element-modeles/factories/element-type';

// TODO：yougetang 临时解决循环依赖问题
// eslint-disable-next-line max-len
export function getSmartArtElementModelConstructorByType(type: ElementModelType) {
    switch (type) {
        case UIModelType.SHAPE:
            return ShapeModel;
        case UIModelType.IMAGE:
            return PictureModel;
        case UIModelType.CONNECTOR:
            return ConnectorModel;
    }
}
